import React from 'react';
import Image from 'next/image';
import { MomentumType } from 'legacy/events/types';

interface MomentumChipProps {
  type: MomentumType;
  displayCount: number;
}

const iconMap = {
  [MomentumType.SELLING_FAST_30_MINUTES]: '/img/icons/selling-fast.svg',
  [MomentumType.SELLING_FAST_24_HOURS]: '/img/icons/grabbed-tix.svg'
};

const getMomentumChipText = (type: MomentumType, displayCount: number) => {
  switch (type) {
    case MomentumType.SELLING_FAST_30_MINUTES:
      return `Selling Fast! ${displayCount}+ sold in the last 30 minutes`;
    case MomentumType.SELLING_FAST_24_HOURS:
      return `${displayCount}+ people grabbed tickets recently`;
    default:
      return null;
  }
};

const momentumChipStylesMap = {
  [MomentumType.SELLING_FAST_30_MINUTES]:
    'bg-gradient-to-r from-[#FFEDEB] to-transparent text-[#60150F]',
  [MomentumType.SELLING_FAST_24_HOURS]:
    'bg-gradient-to-r from-[#ECFEFE] to-transparent text-[#103D48]'
};

const momentumChipAltTextMap = {
  [MomentumType.SELLING_FAST_30_MINUTES]: 'Selling Fast!',
  [MomentumType.SELLING_FAST_24_HOURS]: 'Grabbed Tickets'
};

const MomentumChip: React.FC<MomentumChipProps> = ({ type, displayCount }) => (
  <div
    className={`${momentumChipStylesMap[type]} flex items-center gap-2 h-[24px] w-full rounded-md px-2`}
  >
    <Image
      src={iconMap[type]}
      alt={momentumChipAltTextMap[type]}
      width={40}
      height={40}
    />
    <span>{getMomentumChipText(type, displayCount)}</span>
  </div>
);

export default MomentumChip;
